export const environment = {
	production: false,
	agora: {
		appId: '6c368b93b82a4b3e9fb8e57da830f2a4',
	},
	urls: {
		middlewareURL: '/middleware/',
		stockfishServerURL: '/stockfishserver/',
		chessClientURL: '/chessclient/',
		chessServer: '/chessserver/',
	},
};